import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ClientService } from '../service/client.service';

@Component({
  selector: 'app-confirm-mail',
  templateUrl: './confirm-mail.component.html',
  styleUrls: ['./confirm-mail.component.scss']
})
export class ConfirmMailComponent implements OnInit {

  code: string;
  errorMessage: string = "";

  constructor(
    private route: ActivatedRoute,
    private clientService: ClientService
  ) { }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.code = params.code;
    });
    
    if (this.code === undefined) {
      this.errorMessage = "L'adresse mail n'a pas pu être vérifiée. Veuillez vérifier l'url qui vous a été envoyée par mail."
    } else {
      this.clientService.postMailConfirm(this.code).subscribe(data => {
      }, err => {
        this.errorMessage = "L'adresse mail n'a pas pu être vérifiée. Veuillez vérifier l'url qui vous a été envoyée par mail."
      });
    }
  }

  isError() {
    return this.errorMessage !== "";
  }

}
